import { render, staticRenderFns } from "./StudentHistoryTotal.vue?vue&type=template&id=833827f0&scoped=true&lang=pug&"
import script from "./StudentHistoryTotal.vue?vue&type=script&lang=ts&"
export * from "./StudentHistoryTotal.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHistoryTotal.vue?vue&type=style&index=0&id=833827f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833827f0",
  null
  
)

export default component.exports